<mat-dialog-content>
    <div class="error-dialog">
        <div class="dialog-header">
            <div class="subhead">
                An Error Has Occurred
            </div>
            <button type="button" class="dialog-header-close button-nostyle" (click)="close()"><i class="fas fa-times"></i></button>
        </div>
        <div class="dialog-body">
            <p class="error-dialog-text">
                Please copy the error details and report this issue to IT and try again later.
            </p>
            <p class="error-dialog-text">
                <button type="button"
                        class="button-flat"
                        (click)="copyErrorDetails()">
                    <i class="fas fa-copy"></i> COPY ERROR DETAILS
                </button>
            </p>
            <p class="error-dialog-text error-dialog-pre">{{errorDetails}}</p>
        </div>
    </div>
</mat-dialog-content>
